window.addEventListener("load", function () {
    // Khởi tạo Swiper với cấu hình hiển thị một phần slide tiếp theo
const swiperFeature = new Swiper(".swiperFeature", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 30,
    speed: 1000,
    loop: false,

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});



});
